const features = {
    showAccountTab:                     true,
    LimitedAccountsBlockOpenNewEvents:  true
};

export default features;


// WEBPACK FOOTER //
// ./src/utils/features.js